import React from 'react';
import { View } from 'react-native';
import RadioStrip from './RadioStrip';
import Title from '../Text/Title';

//= ========================================================================

const RadioPanelAdvance = ({
  title, chosenValue, valuesMap, onValueChanged,
}) => (
  <View style={{ marginBottom: 18 }}>
    <Title>{title}</Title>
    <RadioStrip
      chosenValue={chosenValue}
      valuesMap={valuesMap}
      onValueChanged={onValueChanged}
    />
  </View>
);
export default RadioPanelAdvance;
